
const MONTH = 30;
const WEEK = 7;

export const shelfLife = (minimumShelfLife) => {
  if (!minimumShelfLife) {
    return null;
  }

  if (minimumShelfLife > MONTH) {
    return { value: 1, type: 'MONTH' };
  }

  if (minimumShelfLife > WEEK) {
    let weeks = Math.floor((minimumShelfLife - 1) / WEEK);
    weeks = Math.min(weeks, 3); // 22-30 days => 3 weeks +
    return { value: weeks, type: weeks > 1 ? 'WEEKS' : 'WEEK' };
  }

  return { value: minimumShelfLife, type: minimumShelfLife > 1 ? 'DAYS' : 'DAY' };
};

export const isInDays = (minimumShelfLife) =>
  minimumShelfLife <= WEEK;

export const formatShelfLife = (minimumShelfLife, format) => {
  const convertedShelfLife = shelfLife(minimumShelfLife);
  switch (format) {
    case 'short':
      return `${convertedShelfLife.value}${convertedShelfLife.type[0]}`;
    case 'long':
    default:
      return `${convertedShelfLife.value} ${convertedShelfLife.type}`;
  }
};
